import { Component } from "react";
import JWTTokenService from "../core_library/authentication/jwt_token_service";
import AuthWebService from "../service/auth_web_service";
import DataResult from "../data/bean/data_result";
import Config from "../Config";
import UtilBloc from "./util_bloc";
import moment from "moment";

class AuthBloc extends Component {

  static getErrDescByCode(code) {     
    const errorCodes = {
      "2000": {
        "en": "Login User Locked Due To Max Login Attempt",
        "bm": "Pengguna dikunci kerana percubaan log masuk maksimum"
      },
      "2001": {
        "en": "Pending latest information updates. Please try later.",
        "bm": "Menunggu kemas kini maklumat terkini. Sila cuba kemudian."
      },
      "2002": {
        "en": "Login User Locked Due To Max OTP Request",
        "bm": "Pengguna dikunci kerana permintaan OTP telah mencapai had maksimum"
      },

      "1000": {
        "en": "MFA Method Invalid",
        "bm": "Kaedah MFA tidak sah"
      },
      "1001": {
        "en": "MFA Token Invalid",
        "bm": "Token MFA tidak sah"
      },
      "1002": {
        "en": "MFA Auth0 Invalid OOB Channel",
        "bm": "Saluran OOB Auth0 MFA tidak sah"
      },
      //Opt
      "1016": {
        "en": "Your OTP code has expired",
        "bm": "Kod OTP anda telah tamat"
      },
      "1007": {
        "en": "Please kindly enter the correct OTP",
        "bm": "Sila masukkan OTP yang betul"
      },
      // Login Error (1100 - 1199)
      "1100": {
        "en": "Login Invalid",
        "bm": "Log masuk tidak sah"
      },
      "1101": {
        "en": "Invalid Certificate or NRIC number. Please try again.",
        "bm": "Nombor Sijil atau Kad Pengenalan tidak sah. Sila cuba lagi."
      },
      "1106": {
        "en": "Invalid Certificate or NRIC number. Please try again.",
        "bm": "Nombor Sijil atau Kad Pengenalan tidak sah. Sila cuba lagi."
      },
      "1107": {
        "en": "User Not Authenticated",
        "bm": "Pengguna tidak disahkan"
      },
      "1108": {
        "en": "User Not Authorized",
        "bm": "Pengguna tidak dibenarkan"
      },
      "1109": {
        "en": "User Already Logged In",
        "bm": "Pengguna telah pun log masuk"
      },
      "1110": {
        "en": "User Already Logged Out",
        "bm": "Pengguna telah pun log keluar"
      },
      "1111": {
        "en": "User Session Expired",
        "bm": "Sesi pengguna telah tamat"
      },
      "1115": {
        "en": "OTP is not verified",
        "bm": "OTP tidak terverifikasi"
      },
      "1504": {
        "en": "OTP is not verified",
        "bm": "OTP tidak terverifikasi"
      },
      // CSV & Excel Error (1200 - 1299)
      "1200": {
        "en": "CSV File Empty",
        "bm": "CSV File Empty (BM)"
      },
      "1201": {
        "en": "CSV File Invalid",
        "bm": "CSV File Invalid (BM)"
      },
      "1202": {
        "en": "CSV File Read Error",
        "bm": "CSV File Read Error (BM)"
      },
      "1203": {
        "en": "CSV File Write Error",
        "bm": "CSV File Write Error (BM)"
      },
      "1204": {
        "en": "CSV File Parse Error",
        "bm": "CSV File Parse Error (BM)"
      },
      "1205": {
        "en": "CSV File Header Invalid",
        "bm": "CSV File Header Invalid (BM)"
      },
      "1206": {
        "en": "CSV File Data Invalid",
        "bm": "CSV File Data Invalid (BM)"
      },

      "1209": {
        "en": "Excel File Empty",
        "bm": "Excel File Empty (BM)"
      },
      "1210": {
        "en": "Excel File Invalid",
        "bm": "Excel File Invalid (BM)"
      },
      "1211": {
        "en": "Excel File Read Error",
        "bm": "Excel File Read Error (BM)"
      },
      "1212": {
        "en": "Excel File Write Error",
        "bm": "Excel File Write Error (BM)"
      },
      "1213": {
        "en": "Excel File Parse Error",
        "bm": "Excel File Parse Error (BM)"
      },
      "1214": {
        "en": "Excel File Header Invalid",
        "bm": "Excel File Header Invalid (BM)"
      },
      "1215": {
        "en": "Excel File Data Invalid",
        "bm": "Excel File Data Invalid (BM)"
      },

      // Application Error (1300 - 1399)
      "1300": {
        "en": "Setting Not Found",
        "bm": "Setting Not Found (BM)"
      },
      "1301": {
        "en": "Setting Invalid",
        "bm": "Setting Invalid (BM)"
      },
      "1302": {
        "en": "Setting Bin Or Value Empty",
        "bm": "Setting Bin Or Value Empty (BM)"
      },
      "1303": {
        "en": "Label Not Found",
        "bm": "Label Not Found (BM)"
      },
      "1304": {
        "en": "Label Code Empty",
        "bm": "Label Code Empty (BM)"
      },
      "1305": {
        "en": "Master Certificate No Not Found",
        "bm": "Master Certificate No Not Found (BM)"
      },
      "1306": {
        "en": "Edit Cuepacs Member Details for MFA display Failed",
        "bm": "Edit Cuepacs Member Details for MFA display Failed (BM)"
      },
      "1307": {
        "en": "Member Details Not Found",
        "bm": "Member Details Not Found (BM)"
      },

      // System Error (1400 - 1499)
      "1400": {
        "en": "Local Auth Role Not Found",
        "bm": "Local Auth Role Not Found (BM)"
      },
      "1401": {
        "en": "Certificate No Not Found",
        "bm": "Certificate No Not Found (BM)"
      },
      "1402": {
        "en": "Member ID Not Found",
        "bm": "Member ID Not Found (BM)"
      },
      "1403": {
        "en": "Client No Not Found",
        "bm": "Client No Not Found (BM)"
      },
      "1404": {
        "en": "Invalid Get User Info Request",
        "bm": "Invalid Get User Info Request (BM)"
      },
    };

    // Return the description in the requested language, or fallback to 'en' if language not found
    const description = errorCodes[code];
    return description || "Unknown error code";
}

  
  
  //saveAccessToken
  static saveAccessToken(data) {
    sessionStorage.setItem("token", JSON.stringify(data));
  }
 
  //getAccessToken
  static getAccessToken() {    
    return !UtilBloc.isNullOrEmpty(sessionStorage.getItem("token"))
      ? JSON.parse(sessionStorage.getItem("token"))
      : null;
  }

  //saveCertificateNo
  static saveCertificateNo(data) {
    sessionStorage.setItem("certificateNo", JSON.stringify(data));
  }
 
  //getCertificateNo
  static getCertificateNo() {    
    return !UtilBloc.isNullOrEmpty(sessionStorage.getItem("certificateNo"))
      ? JSON.parse(sessionStorage.getItem("certificateNo"))
      : null;
  }

  static saveNRICNo(data) {
    sessionStorage.setItem("nricNo", JSON.stringify(data));
  }
 
  //getCertificateNo
  static getNRICNo() {    
    return !UtilBloc.isNullOrEmpty(sessionStorage.getItem("nricNo"))
      ? JSON.parse(sessionStorage.getItem("nricNo"))
      : null;
  }

  //Checking role is CAC type
  static isCAC() {
    return this.getRoleDetails() == "CAC"
  }
  //Depend on role to get who will accept this submit
  static getSubmittedProposalDesc() {
    let role = this.getRoleDetails();
    let submittedTo = "";
    if (role == "SALES REPRESENTATIVE") {
      submittedTo = "Supervisor";
    }

    if (role == "SUPERVISOR") {
      submittedTo = "CAC";
    }
    
    return submittedTo
  }

  //Checking role is Supervisor type
  static isSupervisor() {
    return this.getRoleDetails() == "SUPERVISOR"
  }

  static getSubChannel(){
    const session =this.checkSession();
    let ChannelId =session.data.meta.metadata.attributes?.subChannel;
    return ChannelId;
  }

  //Save role when user loggin successfully
  static saveRoleDetails(role) {
    sessionStorage.setItem("role", role);
  }

  //Get role when user loggin successfully
  static getRoleDetails() {
    let role = sessionStorage.getItem("role");
    return role || "";
  }

  //Save sign status when user loggin successfully in Customer Flow
  static saveIsSigned(value) {
    sessionStorage.setItem("signed", value == true || value == "true" || value == "TRUE" ? true : false);
  }

  //Get sign status when user loggin successfully in Customer Flow
  static getIsSigned() {
    let signed = sessionStorage.getItem("signed");
    return signed || false;
  }

  static saveIsSameAsInsuredMember(value) {
    sessionStorage.setItem("isSameAsInsuredMember", value == true || value == "Yes" || value == "TRUE" ? true : false);
  }

  //Get sign status when user loggin successfully in Customer Flow
  static getIsSameAsInsuredMember() {
    let isSameAsInsuredMember = sessionStorage.getItem("isSameAsInsuredMember");
    return isSameAsInsuredMember || false;
  }


  


  //Get uuid in QR link
  static getUUID() {
    let clientId = sessionStorage.getItem("uuid");
    return clientId || "";
  }

  //Save uuid in QR link
  static saveUUID(clientId) {
    sessionStorage.setItem("uuid", clientId);
  }

  //Get client in Customer Flow
  static getClientId() {
    let clientId = sessionStorage.getItem("clientId");
    return clientId || "";
  }

  static saveClientId(clientId) {
    sessionStorage.setItem("clientId", clientId);
  }

  //Get client in Customer Flow
  static getNomination() {
    let nomination = sessionStorage.getItem("nomination");
    return nomination || "";
  }

  static saveNomination(nomination) {
    sessionStorage.setItem("nomination", nomination);
  }


  //Get client in Customer Flow
  static getArrangmentCode() {
    let arrangmentCode = sessionStorage.getItem("arrangmentCode");
    return arrangmentCode || "";
  }

  static saveArrangmentCode(arrangmentCode) {
    sessionStorage.setItem("arrangmentCode", arrangmentCode);
  }

  static getProductCode() {
    let productCode = sessionStorage.getItem("productCode");
    return productCode || "";
  }

  static saveProductCode(productCode) {
    sessionStorage.setItem("productCode", productCode);
  }

    //Get client in Customer Flow
    static getClientType() {
      let clientType = sessionStorage.getItem("clientType");
      return clientType || "";
    }
  
    static saveClientType(clientType) {
      sessionStorage.setItem("clientType", clientType);
    }

  //Get agent id in CAC and Supervisor Flow
  static getAgentId() {
    let agentId = sessionStorage.getItem("agentId");
    return agentId || "";
  }

  //Save agent id in CAC and Supervisor Flow
  static saveOtpVerificationMethod(otpVerificationMethod) {
    sessionStorage.setItem("otpVerificationMethod", otpVerificationMethod);
  }
  
  //getAgentId from sessionStorage 
  static getOtpVerificationMethod() {
    let otpVerificationMethod = sessionStorage.getItem("otpVerificationMethod");
    return otpVerificationMethod || "";
  }

  //Save agent id in CAC and Supervisor Flow
  static saveAgentId(agentId) {
    sessionStorage.setItem("agentId", agentId);
  }
  
  //getAgentId from sessionStorage 
  static getAgentId() {
    let agentId = sessionStorage.getItem("agentId");
    return agentId || "";
  }
  
  //saveAgentIdForSuperviorAndCAC for CAC and Supevisor flow
  static saveAgentIdForSuperviorAndCAC(agentId) {
    sessionStorage.setItem("agentId1", agentId);
  }
  
  //getAgentIdForSuperviorAndCAC for CAC and Supevisor flow
  static getAgentIdForSuperviorAndCAC() {
    let agentId = sessionStorage.getItem("agentId1");
    return agentId || "";
  }

  //Save session when it was exprired to avoid user refresh browser to pass token
  static saveExpiredSession(status) {
    sessionStorage.setItem("expired_session", status === true ? 'true' : 'false');
  }
  
  //getExpiredSession to avoid user refresh screen to pass
  static getExpiredSession() {
    let expired_session = sessionStorage.getItem("expired_session");
    return expired_session === 'true';
  }

  //getverifiedOtp to avoid user bypass to another screen
  static verifiedOtp() {
    let verifiedOtp = sessionStorage.getItem("verifiedOtp");
    return verifiedOtp === "true";
  }

  //Url to profile in dashboard screen
  static goToProfile() {
    window.location.href = `/${Config.context}/${Config.routes.generic.dashboard}/myProfile`;
  }

  //Clear all data in sessionStorage when user logout or exprired session in Agent Flow
  static clearSessionData() {
    sessionStorage.removeItem("dataUser");
    sessionStorage.removeItem("tmp_dataUser");
    sessionStorage.removeItem("sessionId");
    sessionStorage.removeItem("expired_session");
    sessionStorage.removeItem("accessible_modules");
    sessionStorage.removeItem("role");
    sessionStorage.removeItem("agentId");
    sessionStorage.removeItem("productId");
    sessionStorage.removeItem("uuid");
    sessionStorage.removeItem("verifiedOtp");
    sessionStorage.removeItem("segment");
    sessionStorage.removeItem("otpVerificationMethod");     
  }

  //Clear all data in sessionStorage when user logout or exprired session in Customer Flow
  static clearSessionDataClient() {
    sessionStorage.removeItem("dataUser");
    sessionStorage.removeItem("tmp_dataUser");
    sessionStorage.removeItem("sessionId");
    sessionStorage.removeItem("expired_session");
    sessionStorage.removeItem("accessible_modules");
    sessionStorage.removeItem("role");
    sessionStorage.removeItem("agentId");
    sessionStorage.removeItem("productId");
    sessionStorage.removeItem("verifiedOtp");
    sessionStorage.removeItem("segment");
    sessionStorage.removeItem("otpVerificationMethod");  
  }

  static saveOtpSessionId(sessionId) {
    sessionStorage.setItem("sessionId", sessionId)
  }

  static getOtpSessionId() {
    return sessionStorage.getItem("sessionId")
  }

  //verifyEmailOtp
  static async verifyEmailOtp(payload) {
    let resp = await AuthWebService.verifyEmailOtp(payload);
    if (resp.success) {
      return new DataResult(true, resp.message, resp);
    } else {
      return new DataResult(false, resp.message, resp);
    }
  }

  //verifySmsOtp
  static async verifySmsOtp(payload,type) {
    let resp = await AuthWebService.verifySmsOtp(payload,type);
    if (resp.success) {
      return new DataResult(true, resp.message, resp);
    } else {
      return new DataResult(false, resp.message, resp);
    }
  }

  //createEmailOtp
  static async createEmailOtp(payload, isResend,type) {
    let resp = await AuthWebService.createEmailOtp(payload, isResend,type);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message, resp);
    }
  }

  //createSmslOtp
  static async createSmsOtp(payload, isResend,type) {
    let resp = await AuthWebService.createSmsOtp(payload, isResend,type);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message, resp);
    }
  }

  //resendSmslOtp
  static async resendSmsOtp(payload, isResend,type) {
    let resp = await AuthWebService.resendSmsOtp(payload, isResend,type);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message, resp);
    }
  }

  //createEmailOtp
  static async createEmailOtp(payload, isResend,type) {
    let resp = await AuthWebService.createEmailOtp(payload, isResend,type);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message, resp);
    }
  }


  static async resendEmailOtp(payload, isResend,type) {
    let resp = await AuthWebService.resendEmailOtp(payload, isResend,type);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message, resp);
    }
  }

  

  //Get list of modules when user login successfully
  static async getAccesibleModules(payload, isResend) {
    let resp = await AuthWebService.getAccesibleModules(payload, isResend);
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message, resp);
    }
  }

  //Login function
  static async login(payload) {
    let resp = await AuthWebService.login(payload);       
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message,resp.data,resp.code);
    }
  }

  //verifyOtpSession
  static async verifyOtpSession(userId,userType) {
    let resp = await AuthWebService.verifyOtpSession(userId,userType);       
    if (resp.success) {
      return new DataResult(true, resp.message, resp.data);
    } else {
      return new DataResult(false, resp.message,resp.data);
    }
  }

  //Check username current is got any active session before 
  static async onVerifyActiveSession(username) {
    let response = await AuthWebService.onVerifyActiveSession(
      username
    );

    return {
      success: response.success,
      data: response.data,
      message: response.data.message,
    };
  }

  //Check proposalId current is got any active session before in Customer Flow
  static async onVerifyValidClientSession(proposalId,checkOnly) {
    let response = await AuthWebService.onVerifyValidClientSession(
      proposalId,checkOnly
    );

    return {
      success: response.success,
      data: response.data,
      message: response.data.message,
    };
  }

  //Logout function in Agent Flow
  static async onRevokeLogout(username) {
    let response = await AuthWebService.onRevokeLogout(
      username
    );

    return {
      success: response.success,
      data: response.data,
      message: response.data.message,
    };
  }

  static async logOutPortal(certId) {        
    let response = await AuthWebService.logOutPortal(certId);
    return {
      success: response.success,
      data: response.data,
      message: response.message,
    };
  }

  //saveAccessModules
  static saveAccessModules(data) {
    sessionStorage.setItem("accessible_modules", JSON.stringify(data));
  }
 
  //getAccessModules
  static getAccessModules() {
    return sessionStorage.getItem("accessible_modules")
      ? JSON.parse(sessionStorage.getItem("accessible_modules"))
      : null;
  }

  //Check which module can access
  static accessible(id, type) {
    if (id == "CLIENT") {
      id = "CONTACT";
    }
    let modules = this.getAccessModules();
    let module ="";
    if(id=="AGENT_MANAGEMENT" || id=="FILE_UPLOAD"){
      module = modules?.[id]
    } else {
      module = modules?.[id + "_MODULE"]
    }
    if (module && module.length > 0) {
      var result = module.filter(obj => {
        return obj === type
      })
      if (result.length > 0) {
        return true
      }
    }
    return false;
  }

  //getDataUser
  static getDataUser() {
    return sessionStorage.getItem("dataUser")
      ? JSON.parse(sessionStorage.getItem("dataUser"))
      : null;
  }

  //getAgentName
  static getAgentName() {
    return sessionStorage.getItem("dataUser")
      ? JSON.parse(sessionStorage.getItem("dataUser")).data.meta?.displayName || ""
      : null;
  }

  //getAgentID
  static getAgentID() {
    return sessionStorage.getItem("dataUser")
      ? JSON.parse(sessionStorage.getItem("dataUser")).data.meta?.userId || ""
      : null;
  }

  //getAgentEmail
  static getAgentEmail() {
    return sessionStorage.getItem("dataUser")
      ? JSON.parse(sessionStorage.getItem("dataUser")).data.meta.metadata?.email || ""
      : null;
  }

  static getAppointmentDate() {
    return sessionStorage.getItem("dataUser")
      ? JSON.parse(sessionStorage.getItem("dataUser")).data.meta.metadata?.appointmentDate?.[0] || moment().format('YYYY-MM-DD')
      : null;
  }


  //Get currentAccessToken
  static async currentAccessToken() {
    let token = "";
    let refreshToken = "";

    let dataUser = JSON.parse(sessionStorage.getItem("dataUser"));
    if (dataUser) {
      token = dataUser.accessToken;
      refreshToken = dataUser.refreshToken;
    }

    return token;
  }

  //verifyToken
  static async verifyToken() {
    let response = await AuthWebService.verifyToken();
    return {
      success: response.success,
      data: response.data,
      message: response.message,
    };
  }

  //get dataUser from tmp_dataUser(after login) or  dataUser (after verify OTP)
  static checkSession() {
    let dataUser = JSON.parse(sessionStorage.getItem("dataUser")) || JSON.parse(sessionStorage.getItem("tmp_dataUser"));
    return dataUser;
  }

  static saveSegment(data) {
    sessionStorage.setItem("segment", JSON.stringify(data));
  }
 
  //getAccessModules
  static getSegment() {
    //console.log("SESSSS",)
    return !UtilBloc.isNullOrEmpty(sessionStorage.getItem("segment"))
      ? JSON.parse(sessionStorage.getItem("segment"))
      : null;
  }
}
export default AuthBloc;
